import NativeApi from 'native-api'
/**
* 获取app设备信息
*/
let deviceInfo
export function deviceInfoReady() {
    return new Promise((resolve, reject) => {
        if (deviceInfo) {
            resolve(deviceInfo)
        } else {
            NativeApi.invoke('getUserInfo', null, (info) => {
                if (info.error) {
                    reject(info.error)
                } else {
                    deviceInfo = info
                    resolve(deviceInfo)
                }
            })
        }
    })
}